<template>
  <Transition name="fade">
    <button
      v-if="isVisible"
      type="button"
      class="top-button"
      title="맨 위로 이동"
      @click="scrollToTop"
    >
      TOP
    </button>
  </Transition>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useThrottleFn } from "@vueuse/core";

/* ==============================
 *  상수
 * ============================== */
const SCROLL_THRESHOLD = 200;

/* ==============================
 *  상태
 * ============================== */
const isVisible = ref(false);

/* ==============================
 *  메서드
 * ============================== */
const handleScroll = useThrottleFn(() => {
  isVisible.value = window.scrollY > SCROLL_THRESHOLD;
}, 100);

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

/* ==============================
 *  라이프사이클
 * ============================== */
onMounted(() => {
  window.addEventListener("scroll", handleScroll, { passive: true });
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
.top-button {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #343a40;
  color: white;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.1rem;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.top-button:hover {
  background-color: #495057;
}

.top-button:focus {
  outline: 2px solid #0d6efd;
  outline-offset: 2px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
